import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import { BarChart2, Calendar, Users, Settings, BookOpen, LogOut, ChevronLeft, ChevronRight, Menu, X, UserPlus } from 'react-feather';
import './Sidebar.css';

function Sidebar({ onLogout, isSuperAdmin }) {
  console.log('🔍 Sidebar received isSuperAdmin:', isSuperAdmin);
  const navigate = useNavigate();
  const location = useLocation();
  const { theme } = useTheme();
  const [isCollapsed, setIsCollapsed] = React.useState(() => {
    return localStorage.getItem('sidebarCollapsed') === 'true';
  });
  const [mobileOpen, setMobileOpen] = React.useState(false);

  React.useEffect(() => {
    localStorage.setItem('sidebarCollapsed', isCollapsed);
  }, [isCollapsed]);

  const logoUrl = theme === 'light' 
    ? 'https://storage.googleapis.com/msgsndr/oNgjqmOcyIwtcMEEfqUj/media/69051e7ade8283bc1015dd30.webp'
    : 'https://storage.googleapis.com/msgsndr/oNgjqmOcyIwtcMEEfqUj/media/69051e7a306550caec6c2c16.webp';

  const isActive = (path) => location.pathname === path;

  const handleNavClick = (path) => {
    navigate(path);
    setMobileOpen(false); // Close mobile menu after navigation
  };

  return (
    <>
      {/* Mobile Header Bar */}
      <div className="mobile-header-bar">
        <h1 className="mobile-header-title">{isSuperAdmin ? 'Admin Dashboard' : 'Dashboard'}</h1>
        <button 
          className="mobile-hamburger"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <Menu size={20} />
        </button>
      </div>

      {/* Mobile Overlay */}
      {mobileOpen && (
        <div 
          className="sidebar-mobile-overlay"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
        {/* Mobile Close Button */}
        <button 
          className="sidebar-mobile-close"
          onClick={() => setMobileOpen(false)}
        >
          <X size={24} />
        </button>

        <div className="sidebar-header">
          {!isCollapsed && (
            <img 
              src={logoUrl} 
              alt="EventPic Live" 
              className="sidebar-logo"
            />
          )}
          <button 
            className="sidebar-collapse-btn desktop-only"
            onClick={() => setIsCollapsed(!isCollapsed)}
            title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
          </button>
        </div>

        <nav className="sidebar-nav">
          <button 
            onClick={() => handleNavClick('/admin/dashboard')} 
            className={`sidebar-nav-item ${isActive('/admin/dashboard') ? 'active' : ''}`}
          >
            <BarChart2 size={20} /> {!isCollapsed && 'Dashboard'}
          </button>

          <button 
            onClick={() => handleNavClick('/events')} 
            className={`sidebar-nav-item ${isActive('/events') ? 'active' : ''}`}
          >
            <Calendar size={20} /> {!isCollapsed && 'Events'}
          </button>

          {isSuperAdmin && (
            <button 
              onClick={() => handleNavClick('/admin/clients')} 
              className={`sidebar-nav-item ${isActive('/admin/clients') ? 'active' : ''}`}
            >
              <Users size={20} /> {!isCollapsed && 'Clients'}
            </button>
          )}

          {!isSuperAdmin && (
            <button 
              onClick={() => handleNavClick('/team')} 
              className={`sidebar-nav-item ${isActive('/team') ? 'active' : ''}`}
            >
              <UserPlus size={20} /> {!isCollapsed && 'Team'}
            </button>
          )}

          <button 
            onClick={() => handleNavClick('/admin/settings')} 
            className={`sidebar-nav-item ${isActive('/admin/settings') ? 'active' : ''}`}
          >
            <Settings size={20} /> {!isCollapsed && 'Settings'}
          </button>

          <button 
            onClick={() => handleNavClick('/support')} 
            className={`sidebar-nav-item ${isActive('/support') ? 'active' : ''}`}
          >
            <BookOpen size={20} /> {!isCollapsed && 'Support'}
          </button>
        </nav>

        <div className="sidebar-footer">
          <button 
            onClick={() => {
              onLogout();
              setMobileOpen(false);
            }} 
            className="sidebar-logout"
          >
            <LogOut size={20} /> {!isCollapsed && 'Logout'}
          </button>
          {!isCollapsed && (
            <p style={{
              fontSize: '12px',
              color: '#9CA3AF',
              textAlign: 'center',
              margin: '16px 0 0 0',
              padding: '0 16px'
            }}>
              © {new Date().getFullYear()} EventPic Live
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default Sidebar;
